import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { LOGIN_PAGE_URL } from '../models';

declare var $: any;

@Component({
  standalone: false,
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit, OnDestroy {

  hasMenus: boolean = false;
  collapse: boolean = false;

  private routerSubscription: Subscription = null;

  constructor(
    private router: Router
  ) { }


  ngOnInit() {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.hasMenus = event.url.indexOf(LOGIN_PAGE_URL) === -1;
      }
    });
  }
  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
  getValue(menuExpanded) {
    this.collapse = !menuExpanded;
  }
}
